import { createBrowserRouter, Navigate } from "react-router";

import { RouteLoadingPage } from "./components/route-loading-page";

export const router = createBrowserRouter([
  {
    path: "/",
    HydrateFallback: RouteLoadingPage,
    lazy: () => import("./routes/root-route"),
    children: [
      { index: true, lazy: () => import("./routes/overview-page") },
      { path: "admin", element: <Navigate replace to="/" /> },
      { path: "environments", lazy: () => import("./routes/environment-catalogue-page") },

      { path: "environments/new", lazy: () => import("./routes/environment-onboarding-page") },
      { path: "environments/:environmentId/:tab?", lazy: () => import("./routes/environment-detail-page") },
      { path: "roles", lazy: () => import("./routes/role-catalogue-page") },
      { path: "roles/default/edit", lazy: () => import("./routes/role-policy-page") },
      { path: "roles/:roleKey/edit", lazy: () => import("./routes/role-policy-page") },
      { path: "roles/environments/:environmentId/edit", lazy: () => import("./routes/environment-role-policy-page") },
      { path: "roles/:roleKey/environments/:environmentId/edit", lazy: () => import("./routes/environment-role-policy-page") },
      { path: "roles/environments/:environmentId/tenants/:tenantId/edit", lazy: () => import("./routes/tenant-role-policy-page") },
      { path: "roles/:roleKey/environments/:environmentId/tenants/:tenantId/edit", lazy: () => import("./routes/tenant-role-policy-page") },
      { path: "role-policies", element: <Navigate replace to="/roles" /> },
      { path: "audit", lazy: () => import("./routes/audit-page") },
      { path: "features", lazy: () => import("./routes/flag-catalogue-page") },
      { path: "features/new", lazy: () => import("./routes/flag-create-page") },
      { path: "features/:flagId/edit", lazy: () => import("./routes/flag-editor-page") },
      { path: "changelog", lazy: () => import("./routes/changelog-catalogue-page") },
      { path: "changelog/new", lazy: () => import("./routes/changelog-create-page") },
      { path: "changelog/:releaseId/edit", lazy: () => import("./routes/changelog-editor-page") },
      { path: "flags", element: <Navigate replace to="/features" /> },
      { path: "flags/:flagId", lazy: () => import("./routes/legacy-flag-route") },
      { path: "oauth-providers", lazy: () => import("./routes/oauth-provider-catalogue-page") },
      { path: "oauth-providers/new", lazy: () => import("./routes/oauth-provider-create-page") },
      { path: "oauth-providers/:providerId/edit", lazy: () => import("./routes/oauth-provider-editor-page") },
      { path: "oauth-providers/:providerId", lazy: () => import("./routes/legacy-oauth-provider-route") },
    ],
  },
]);
